module.exports = __webpack_public_path__ + "media/flags/mn-96fe6b07.svg";